import {useContext} from "react";
import {Navigate, Outlet} from "react-router-dom";
import AuthContext from "../src/contexts/AuthContext";
import LoadingScreen from "./components/LoadingScreen";

const ProtectedRoute = () => {
    const {user, loading} = useContext(AuthContext);

    if (loading) return <LoadingScreen/>;

    return user ? (<Outlet/>) :(
        alert("This is a protected route, redirecting to login page"),
        <Navigate to="/signin"/>)
};

export default ProtectedRoute;